import { useState, useEffect } from 'react';

const initalizedScript: HTMLScriptElement[] = [];

const useGoogleMapsApi = (apiKey: String) => {
  const [googleApi, setGoogleApi] = useState();

  useEffect(() => {
    // if the window object is already available
    if ((window as any).google) {
      setGoogleApi((window as any).google);
      return undefined;
    }

    const onLoad = () => {
      setGoogleApi((window as any).google);
    };

    const src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;

    const existingScript = initalizedScript.find(elem => elem.src === src);

    if (existingScript) {
      existingScript.addEventListener('load', onLoad);
      return undefined;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    script.addEventListener('load', onLoad);
    document.head.appendChild(script);
    initalizedScript.push(script);

    return () => {
      script.removeEventListener('load', onLoad);
      script.remove();
      initalizedScript.splice(
        initalizedScript.findIndex(elem => elem.src === src)
      );
    };
  }, [apiKey]);

  return googleApi;
};

export default useGoogleMapsApi;
